import { render, staticRenderFns } from "./GenForm.vue?vue&type=template&id=5fc3a94c&scoped=true&"
import script from "./GenForm.vue?vue&type=script&lang=js&"
export * from "./GenForm.vue?vue&type=script&lang=js&"
import style0 from "./GenForm.vue?vue&type=style&index=0&id=5fc3a94c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc3a94c",
  null
  
)

export default component.exports